import { inject } from '@angular/core';
import { AuthProvider, AuthType } from '../models';
import { HttpEvent, HttpInterceptorFn } from '@angular/common/http';
import { AUTH_PROVIDER } from '../tokens';
import { RBR_API_CONFIG } from '../rbr-api.config';
import { Observable } from 'rxjs';

const requiredProviderMethodKeys = {
    [AuthType.ApiKey]: ['getApiKey', 'getLanguageCode'],
    [AuthType.IAM_Token]: ['getCountryCode', 'getLanguageCode', 'getToken']
};

const validateProvider = (provider: AuthProvider): void => {
    const type = provider.getType();
    const requiredKeys = requiredProviderMethodKeys[type] || [];
    for (const key of requiredKeys) {
        if (!provider[key as keyof AuthProvider]) {
            throw new Error(`Provider is missing required method: ${key} of type ${type}`);
        }
    }
};

export const authInterceptor: HttpInterceptorFn = (request, next): Observable<HttpEvent<any>> => {
    const config = inject(RBR_API_CONFIG);
    if (!request.url.includes(config.apiBaseUrl)) {
        return next(request);
    }

    const provider = inject(AUTH_PROVIDER);
    let headers: { [key: string]: string } = {};

    validateProvider(provider);

    switch (provider.getType()) {
        case AuthType.IAM_Token:
            headers = {
                'X-APPLICATION-ID': config.applicationId,
                'X-APPLICATION-COUNTRY-CODE': provider.getCountryCode!(),
                'X-CA-APPLICATION-LANG-CODE': provider.getLanguageCode(),
                Authorization: `Bearer ${provider.getToken!()}`
            };
            break;
        case AuthType.ApiKey:
        default:
            headers = {
                'X-APPLICATION-API-KEY': provider.getApiKey!(),
                'X-CA-APPLICATION-LANG-CODE': provider.getLanguageCode()
            };
    }

    request = request.clone({
        setHeaders: headers
    });

    return next(request);
};
